export default "__VITE_ASSET__orAhV5c9__"